// import axios from "axios";
import React, { useEffect, useState } from "react";
import { callApi } from "../../../../api";
// import CustomSpinner from "../../../../components/CustomSpinner";
import { useAuth } from "../../../../hooks/useAuth";
import "../SelectTheme/ThemeDetail/styles.scss";
import PreviewLoading from "./PreviewLoading";

const PreviewDeployedWebsite = ({ deployedUrl }) => {
  const [isPreviewAvaible, setIsPreviewAvailable] = useState(false);

  const { selectedBusiness } = useAuth();

  let count = 0;

  // try for 1 mins in 30 secs interval
  const checkWebsitePreview = async () => {
    if (count < 6 && deployedUrl) {
      const checkWebsitePreviewRes = await callApi(
        `/protected/business/${
          selectedBusiness?.id
        }/checkwebsitepreview?url=${encodeURIComponent(deployedUrl)}`
      );

      if (!checkWebsitePreviewRes?.data?.isPreviewWebsite) {
        count += 1;
        setTimeout(async () => {
          await checkWebsitePreview();
        }, 10000);
      }
      return checkWebsitePreviewRes;
    }
    return { status: false, message: "Please check preview after some time." };
  };

  useEffect(async () => {
    const isWebsitePreviewAvailable = await checkWebsitePreview();

    if (
      isWebsitePreviewAvailable?.status &&
      isWebsitePreviewAvailable?.data?.isPreviewWebsite
    ) {
      // const res = await axios.get(deployedUrl);
      setIsPreviewAvailable(true);
    }
  }, []);

  return (
    <>
      <div className="browser-container">
        <div className="browser-row">
          <div className="browser-column browser-left">
            <span className="browser-dot" style={{ background: "#ED594A" }} />
            <span className="browser-dot" style={{ background: "#FDD800" }} />
            <span className="browser-dot" style={{ background: "#5AC05A" }} />
          </div>
          <div className="browser-column browser-middle">
            <input
              className="browser-input"
              type="text"
              value="https://www.yourwebsite.com"
            />
          </div>
          <div className="browser-column browser-right">
            <div style={{ float: "right" }}>
              <span className="browser-bar" />
              <span className="browser-bar" />
              <span className="browser-bar" />
            </div>
          </div>
        </div>

        <div className="browser-content" style={{ height: "650px" }}>
          <div className="d-flex justify-content-center">
            {!isPreviewAvaible ? (
              <PreviewLoading />
            ) : (
              <iframe
                title="Webpage"
                width="100%"
                height="420px"
                sandbox="allow-same-origin allow-scripts"
                // srcDoc={htmlContent}
                src={deployedUrl}
                // onLoad={() => setLoading(false)}
                style={{ border: "none", zoom: "1.9" }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewDeployedWebsite;
